module.exports = __webpack_public_path__ + "img/Icon_WriteBoardBtn.129ee74d.svg";